import { render, staticRenderFns } from "./PublishList.vue?vue&type=template&id=0f90e69f&scoped=true&"
import script from "./PublishList.vue?vue&type=script&lang=js&"
export * from "./PublishList.vue?vue&type=script&lang=js&"
import style0 from "./PublishList.vue?vue&type=style&index=0&id=0f90e69f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90e69f",
  null
  
)

export default component.exports